import { createSlice } from "@reduxjs/toolkit"

export const currentOrderSlice = createSlice({
    name: "current-order",
    initialState: {
        currentOrderId: null,
        currentTableOrderId: null,
    },
    reducers: {
        setCurrentOrder: (state, action) => {
            state.currentOrderId = action.payload
            state.currentTableOrderId = null
        },
        setCurrentTableOrder: (state, action) => {
            state.currentTableOrderId = action.payload
            state.currentOrderId = null
        },
    }
})

export const {
    setCurrentOrder,
    setCurrentTableOrder,
} = currentOrderSlice.actions